module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[45]410.3ce8d2c.woff2";